// extracted by mini-css-extract-plugin
export default {"container":"CardGapMenuEntry_container__VvGng","icon":"CardGapMenuEntry_icon__FF411","tooltip":"CardGapMenuEntry_tooltip__8uviY"};